import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.members');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-members',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.members/view.scss */
/* src/app/page.members/view.scss: no such file or directory */`],
})
export class PageMembersComponent implements OnInit {
    public loading: boolean = false;
    public permissionsExpanded: boolean = false;
    public members: any[] = [];
    public invitations: any[] = [];
    public subscription: any = null;
    public office: any = null;
    public permissions: any = {};

    public search: any = {
        text: "",
        role: ""
    };

    public roles: any[] = [
        { code: 'TENANT_ADMIN', label: '소속관리자' },
        { code: 'TENANT_MEMBER', label: '사용자' }
    ];

    public showInviteModal: boolean = false;
    public inviting: boolean = false;
    public issuedLink: string = '';
    public issuedEmail: string = '';
    public issuedExpiresAt: string = '';
    public inviteData: any = { email: '', name: '' };
    public deleteTarget: any = null;
    public deletingMember: boolean = false;

    public permissionRows: any[] = [
        { label: '고객·사건·기한·문서 업무', admin: '가능', member: '가능' },
        { label: '구성원 초대·삭제', admin: '가능', member: '불가' },
        { label: '사용자 역할 변경', admin: '가능', member: '불가' },
        { label: '계약 타입·사용 인원 확인', admin: '가능', member: '불가' },
        { label: '계약 타입·인원 변경', admin: '불가', member: '불가' },
        { label: '사무소 기본 설정', admin: '가능', member: '불가' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        if (!this.isTenantAdmin()) {
            await this.service.modal.error('소속관리자만 구성원 관리 화면을 사용할 수 있습니다.');
            this.service.href('/dashboard');
            return;
        }
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("list", this.search);
        if (code === 200) {
            this.members = this.sortMembers(data.members || []);
            this.invitations = data.invitations || [];
            this.subscription = data.subscription || null;
            this.office = data.office || null;
            this.permissions = data.permissions || {};
        } else {
            await this.service.modal.error(data?.message || "멤버 정보를 불러오지 못했습니다.");
        }

        this.loading = false;
        await this.service.render();
    }

    public async togglePermissions() {
        this.permissionsExpanded = !this.permissionsExpanded;
        await this.service.render();
    }

    public async filterByRole(role: string) {
        this.search.role = this.search.role === role ? "" : role;
        await this.load();
    }

    public async openInvite() {
        if (this.subscription && !this.subscription.canInvite) {
            await this.service.modal.error(this.inviteDisabledReason());
            return;
        }
        this.inviteData = { email: '', name: '' };
        this.issuedLink = '';
        this.issuedEmail = '';
        this.issuedExpiresAt = '';
        this.showInviteModal = true;
        await this.service.render();
    }

    public async closeInvite() {
        this.showInviteModal = false;
        this.issuedLink = '';
        this.issuedEmail = '';
        this.issuedExpiresAt = '';
        await this.service.render();
    }

    public async invite() {
        if (this.inviting || this.issuedLink) return;
        if (!this.inviteData.email) {
            await this.service.modal.error("이메일을 입력해주세요.");
            return;
        }
        this.inviting = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("invite", this.inviteData);
            if (code === 200) {
                this.issuedLink = data?.result?.link || '';
                this.issuedEmail = this.inviteData.email;
                this.issuedExpiresAt = data?.result?.expiresAt || '';
                await this.load();
            } else {
                await this.service.modal.error(data?.message || "초대에 실패했습니다.");
            }
        } catch {
            await this.service.modal.error("초대 링크를 발급하지 못했습니다. 다시 시도해주세요.");
        } finally {
            this.inviting = false;
            await this.service.render();
        }
    }

    public async copyInvitationLink() {
        if (!this.issuedLink) return;
        try {
            await navigator.clipboard.writeText(this.issuedLink);
            await this.service.modal.success('초대 링크를 복사했습니다. 지정한 이메일의 직원에게만 전달해주세요.');
        } catch {
            await this.service.modal.error('자동 복사가 안 됩니다. 표시된 링크를 직접 선택해 복사해주세요.');
        }
    }

    public async cancelInvitation(invitation: any) {
        const confirmed = await this.service.modal.show({
            title: '초대 취소', message: `${invitation.email} 초대를 취소하시겠습니까?`,
            action: '초대 취소', cancel: '돌아가기', status: 'warning', actionBtn: 'warning'
        });
        if (!confirmed) return;
        const { code, data } = await wiz.call('cancel_invitation', { id: invitation.id });
        if (code === 200) await this.load();
        else await this.service.modal.error(data?.message || '초대를 취소하지 못했습니다.');
    }

    public async openDeleteModal(member: any, event: any = null) {
        event?.stopPropagation();
        this.deleteTarget = member;
        await this.service.render();
    }

    public async closeDeleteModal() {
        if (this.deletingMember) return;
        this.deleteTarget = null;
        await this.service.render();
    }

    public async removeMember() {
        if (!this.deleteTarget || this.deletingMember) return;
        const member = this.deleteTarget;
        this.deletingMember = true;
        await this.service.render();

        const { code, data } = await wiz.call("remove", { id: member.id });
        this.deletingMember = false;
        if (code === 200) {
            this.deleteTarget = null;
            await this.load();
        } else {
            await this.service.modal.error(data?.message || '사용자를 삭제하지 못했습니다.');
            await this.service.render();
        }
    }

    public async changeMemberRole(member: any, role: string) {
        if (!member?.canChangeRole || member.role === role) return;
        const currentLabel = this.roleLabel(member.role);
        const nextLabel = this.roleLabel(role);
        const confirmed = await this.service.modal.show({
            title: '역할 변경 확인',
            message: `${member.name}님의 역할을 ${currentLabel}에서 ${nextLabel}로 변경하시겠습니까?`,
            action: `${nextLabel}로 변경`,
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!confirmed) {
            await this.service.render();
            return;
        }

        const { code, data } = await wiz.call('update_role', { id: member.id, role });
        if (code === 200) {
            await this.service.modal.success('역할이 변경되었습니다.');
            await this.load();
        } else {
            await this.service.modal.error(data?.message || '역할을 변경하지 못했습니다.');
        }
    }

    public roleClass(role: string) {
        switch (role) {
            case 'TENANT_ADMIN': return 'bg-purple-100 text-purple-700';
            case 'TENANT_MEMBER': return 'bg-blue-100 text-blue-700';
            default: return 'bg-gray-100 text-gray-600';
        }
    }

    public roleLabel(role: string) {
        return role === 'TENANT_ADMIN' ? '소속관리자' : '사용자';
    }

    private sortMembers(members: any[]) {
        return [...members].sort((a, b) => {
            if (!!a.isCurrent !== !!b.isCurrent) return a.isCurrent ? -1 : 1;
            return String(a.joined || '').localeCompare(String(b.joined || ''));
        });
    }

    public isTenantAdmin() {
        const role = String(this.service?.auth?.session?.tenant_role || '').toUpperCase();
        return role === 'TENANT_ADMIN' || role === 'TENANT_OWNER';
    }

    public inviteDisabledReason() {
        if (!this.subscription) return "계약 사용 인원 정보를 확인한 뒤 다시 시도해주세요.";
        if (!this.subscription.limitConfigured && ['A', 'B', 'C', 'D'].indexOf(this.subscription.planType) >= 0) {
            return `${this.subscription.planType}타입 계약의 사용 인원 한도가 아직 설정되지 않았습니다.`;
        }
        if (this.subscription.atLimit) {
            return `현재 ${this.subscription.usedSeats}명 / 한도 ${this.subscription.seatLimit}명입니다. 추가 초대에는 요금제 변경이 필요합니다.`;
        }
        return "현재 계약에서는 멤버를 추가할 수 없습니다.";
    }
}

export default PageMembersComponent;